// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { LoadingOutlined } from "@ant-design/icons";
import React from "react";

export const SpinIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;
